// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__MYFtM","btn":"styles_btn__9-W58","text":"styles_text__KdmJ6"};